import 'normalize.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as filters from '@/filters'
import sso from '@/utils/api/sso'
import watermark from '@dp/watermark'
import Vant from 'vant';
import 'vant/lib/index.css';
import VueClipboard from 'vue-clipboard2'
Vue.use(Vant);
Vue.use(VueClipboard)
Vue.config.productionTip = false

// 注册全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
watermark(document.body, {
  backgroundColor: '#f2f4f9',
  urlPrefix: '/api-wm'
})

let SSOWeb = require('@mtfe/sso-web').default
let { host, protocol } = window.location
let clientId = process.env.VUE_APP_CLIENT_ID
let logoutUri = ''
let redirectHost = `/callback`
let ssoWeb: any = new SSOWeb({
  clientId: clientId,
  accessEnv: process.env.VUE_APP_SSO_ACCESS_ENV,
  logoutUri: logoutUri,
  callbackUrl: redirectHost
})
let win = window as any
win.ssoWeb = ssoWeb
ssoWeb.login().then(ssoid => {
  if (typeof ssoid === 'string') {
    sso.setSsoid(ssoid)
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})
